import { useQuery } from '@tanstack/react-query';
import { CASE_CHECKLIST_KEY } from '../../utils/constants/queryKeys';
import { getCaseChecklist } from '../services/fn-api/Cases';

export const useGetCaseChecklist = (caseId: number) => {
  return useQuery({
    queryKey: [CASE_CHECKLIST_KEY, caseId],
    queryFn: () => getCaseChecklist(caseId),
    enabled: !!caseId,
  });
};
